<template>
  <div class="exhibit-page">
    <!-- Hero Section with Background and Form -->
    <section class="hero-section">
      <div class="hero-container">
        <div class="hero-text">
          <h1 class="page-title">The Kingdom's Leading AI Exhibition & Conference</h1>
        </div>
        <div class="hero-form">
          <div class="form-card">
            <h2 class="form-title">Unlock Exclusive Exhibition Opportunities</h2>
            <form @submit.prevent="handleSubmit">
              <div class="form-row">
                <div class="form-group">
                  <label for="fullName">Full Name*</label>
                  <input type="text" id="fullName" v-model="formData.fullName" required />
                </div>
                <div class="form-group">
                  <label for="companyName">Company name*</label>
                  <input type="text" id="companyName" v-model="formData.companyName" required />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label for="email">Business Email*</label>
                  <input type="email" id="email" v-model="formData.email" required />
                </div>
                <div class="form-group">
                  <label for="phone">Phone number*</label>
                  <input type="tel" id="phone" v-model="formData.phone" placeholder="+976" required />
                </div>
              </div>
              <button type="submit" class="submit-button">Download Brochure</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- Who Is This Conference For Section -->
    <section class="conference-for-section">
      <div class="container-wide">
        <h2 class="conference-title">Who Is This Conference For?</h2>
        
        <div class="conference-grid">
          <!-- Enterprises -->
          <div class="conference-card">
            <h3 class="conference-heading">Enterprises</h3>
            <ul class="conference-list">
              <li>
                <span class="check-icon">✓</span>
                <span>Bespoke meetups</span>
              </li>
              <li>
                <span class="check-icon">✓</span>
                <span>Exclusive workshops to demonstrate</span>
              </li>
              <li>
                <span class="check-icon">✓</span>
                <span>Prime speaking slots</span>
              </li>
              <li>
                <span class="check-icon">✓</span>
                <span>Introductions to top decision makers/ govt officers</span>
              </li>
            </ul>
          </div>

          <!-- SME -->
          <div class="conference-card">
            <h3 class="conference-heading">SME</h3>
            <ul class="conference-list">
              <li>
                <span class="check-icon">✓</span>
                <span>Access to top decision-makers</span>
              </li>
              <li>
                <span class="check-icon">✓</span>
                <span>Brand awareness via our 300+ media network</span>
              </li>
              <li>
                <span class="check-icon">✓</span>
                <span>Exclusive networking hours</span>
              </li>
              <li>
                <span class="check-icon">✓</span>
                <span>Pre & post event networking via app</span>
              </li>
            </ul>
          </div>

          <!-- Startups & scaleup's -->
          <div class="conference-card">
            <h3 class="conference-heading">Startups & scaleup's</h3>
            <ul class="conference-list">
              <li>
                <span class="check-icon">✓</span>
                <span>Meet investors in person</span>
              </li>
              <li>
                <span class="check-icon">✓</span>
                <span>Get access to a 110k strong AI community</span>
              </li>
              <li>
                <span class="check-icon">✓</span>
                <span>Pitch your product to over 3k+ decision-makers</span>
              </li>
              <li>
                <span class="check-icon">✓</span>
                <span>Find consultants, developers and potential business partners</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- Who's Joining Section -->
    <section class="whos-joining-section">
      <div class="container-wide">
        <h2 class="joining-title">Who's Joining the INTERNATIONAL EDU TRAVEL, 2026</h2>
        
        <div class="stats-grid">
          <!-- Region Stats -->
          <div class="stats-card region-stats">
            <div class="region-bars">
              <div class="region-bar" style="flex: 30;">
                <div class="region-label">30%</div>
                <div class="region-name">Middle East</div>
              </div>
              <div class="region-bar" style="flex: 28;">
                <div class="region-label">28%</div>
                <div class="region-name">Asia</div>
              </div>
              <div class="region-bar" style="flex: 22;">
                <div class="region-label">22%</div>
                <div class="region-name">Europe</div>
              </div>
              <div class="region-bar" style="flex: 17;">
                <div class="region-label">17%</div>
                <div class="region-name">USA</div>
              </div>
              <div class="region-bar" style="flex: 3;">
                <div class="region-label">3%</div>
                <div class="region-name">Canada</div>
              </div>
            </div>
          </div>

          <!-- Job Level Stats -->
          <div class="stats-card job-level-stats">
            <h3 class="card-title">By Job Level</h3>
            <div class="stat-item">
              <div class="stat-bar" style="width: 72%;"></div>
              <div class="stat-info">
                <span class="stat-percent">72%</span>
                <span class="stat-label">C-Level / Director / VP / Founder</span>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-bar" style="width: 10%;"></div>
              <div class="stat-info">
                <span class="stat-percent">10.0%</span>
                <span class="stat-label">Heads / Manager</span>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-bar" style="width: 10%;"></div>
              <div class="stat-info">
                <span class="stat-percent">10.0%</span>
                <span class="stat-label">Senior Data Scientists & Engineers</span>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-bar" style="width: 4%;"></div>
              <div class="stat-info">
                <span class="stat-percent">4.0%</span>
                <span class="stat-label">Professor / PhD /Doctor / Academic</span>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-bar" style="width: 4%;"></div>
              <div class="stat-info">
                <span class="stat-percent">4.0%</span>
                <span class="stat-label">Developers</span>
              </div>
            </div>
          </div>
        </div>

        <div class="stats-grid-bottom">
          <!-- Company Size Stats -->
          <div class="stats-card company-size-stats">
            <h3 class="card-title">By Company Size</h3>
            <div class="company-boxes">
              <div class="company-box">
                <div class="company-percent">53%</div>
                <div class="company-range">1000-10,000</div>
              </div>
              <div class="company-box">
                <div class="company-percent">34%</div>
                <div class="company-range">Upto 1000</div>
              </div>
              <div class="company-box">
                <div class="company-percent">13%</div>
                <div class="company-range">10000 & over</div>
              </div>
            </div>
          </div>

          <!-- Sector Stats -->
          <div class="stats-card sector-stats">
            <h3 class="card-title">By Sector</h3>
            <div class="sector-list">
              <div class="sector-item">
                <div class="sector-name">Enterprises/Corporates</div>
                <div class="sector-bar-wrapper">
                  <div class="sector-bar" style="width: 38%;"></div>
                  <span class="sector-percent">38%</span>
                </div>
              </div>
              <div class="sector-item">
                <div class="sector-name">Technology</div>
                <div class="sector-bar-wrapper">
                  <div class="sector-bar" style="width: 26%;"></div>
                  <span class="sector-percent">26%</span>
                </div>
              </div>
              <div class="sector-item">
                <div class="sector-name">Startups</div>
                <div class="sector-bar-wrapper">
                  <div class="sector-bar" style="width: 19%;"></div>
                  <span class="sector-percent">19%</span>
                </div>
              </div>
              <div class="sector-item">
                <div class="sector-name">Government & Public sector</div>
                <div class="sector-bar-wrapper">
                  <div class="sector-bar" style="width: 8%;"></div>
                  <span class="sector-percent">8%</span>
                </div>
              </div>
              <div class="sector-item">
                <div class="sector-name">Investors, Advisory & Consulting</div>
                <div class="sector-bar-wrapper">
                  <div class="sector-bar" style="width: 3%;"></div>
                  <span class="sector-percent">3%</span>
                </div>
              </div>
              <div class="sector-item">
                <div class="sector-name">Academics</div>
                <div class="sector-bar-wrapper">
                  <div class="sector-bar" style="width: 4%;"></div>
                  <span class="sector-percent">4%</span>
                </div>
              </div>
              <div class="sector-item">
                <div class="sector-name">Others (Associations, Media, Independent Developers)</div>
                <div class="sector-bar-wrapper">
                  <div class="sector-bar" style="width: 10%;"></div>
                  <span class="sector-percent">10%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Gateway Section -->
    <section class="gateway-section">
      <div class="gateway-container">
        <div class="gateway-content">
          <h2 class="gateway-title">Your Gateway to AI's Finest</h2>
          <p class="gateway-text">
            The 3rd edition of the INTERNATIONAL EDU TRAVEL is on its way. The finest names in AI will be meeting again in Riyadh.
          </p>
          <button class="gateway-btn" @click="scrollToTop">Book a Meeting</button>
        </div>
        <div class="gateway-features">
          <div class="gateway-feature">
            <div class="feature-icon">🏢</div>
            <h3 class="feature-title">One exhibition - 8+ tracks</h3>
            <p class="feature-text">Dedicated tracks for the most important verticals in applied AI</p>
          </div>
          <div class="gateway-feature">
            <div class="feature-icon">🎤</div>
            <h3 class="feature-title">250+ C-Suite speakers</h3>
            <p class="feature-text">Top names in the AI arena and access to year round reports & insights.</p>
          </div>
          <div class="gateway-feature">
            <div class="feature-icon">🏛️</div>
            <h3 class="feature-title">Access to government bodies</h3>
            <p class="feature-text">Meet with family offices, HNIs, regulators & government representatives in person.</p>
          </div>
          <div class="gateway-feature">
            <div class="feature-icon">🛠️</div>
            <h3 class="feature-title">Hands-on workshops</h3>
            <p class="feature-text">Hands-on workshops on Applied AI frameworks; Your New Chief AI Officer.</p>
          </div>
          <div class="gateway-feature">
            <div class="feature-icon">🌐</div>
            <h3 class="feature-title">Global AI Advisory Board</h3>
            <p class="feature-text">The official AI Advisory Board steering the agenda to lead the global dialogue on AI.</p>
          </div>
          <div class="gateway-feature">
            <div class="feature-icon">🔗</div>
            <h3 class="feature-title">Co-located with the Global Blockchain Show & Global Games Show</h3>
            <p class="feature-text">Giving you access to 250+ speakers in the Web3, Blockchain and Crypto world.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Package Banner Section -->
    <section class="package-banner-section">
      <div class="container-wide">
        <div class="banner-content">
          <h2 class="banner-title">Packages Starting From Just $1900!</h2>
          <button class="banner-btn" @click="scrollToTop">Book A Meeting</button>
        </div>
        <p class="banner-subtitle">
          Get your brand associated with 3 events with just ONE package!<br />
          Exhibit the INTERNATIONAL EDU TRAVEL and get complimentary branding at the Global Blockchain Show and Global Games Show
        </p>
      </div>
    </section>

    <!-- Top 3 Recommended Ways Section -->
    <section class="top-ways-section">
      <div class="container-wide">
        <h2 class="ways-title">Top 3 Recommended Ways To Get Involved</h2>
        
        <div class="ways-grid">
          <div class="way-card">
            <h3 class="way-heading">Branding Package + Speaking Slot</h3>
            <p class="way-description">
              Out of time to man a stand? Pick this package - get your logos everywhere without lifting a finger! BONUS: Add on a speaking slot to get your leadership team on stage. The easy no-frills way to get involved at short notice!
            </p>
          </div>

          <div class="way-card">
            <h3 class="way-heading">Coffee / Water Exhibit</h3>
            <p class="way-description">
              Want to be noticed by EVERYONE? 3000+ of the top 1% will have multiple coffees and water through the two days - each time they do, make sure they see your logo!
            </p>
          </div>

          <div class="way-card">
            <h3 class="way-heading">Exhibition Stand</h3>
            <p class="way-description">
              Collected thousands of leads' at this year's major expos? Now start having real conversations with the top 1%. Everyone that walks by is a senior decision-maker, book a stand and make sure your team are there to meet them.
            </p>
          </div>
        </div>

        <div class="ways-cta">
          <button class="ways-cta-btn" @click="scrollToTop">Book A Meeting</button>
        </div>
      </div>
    </section>

    <!-- Limitless Opportunities Section -->
    <section class="limitless-section">
      <div class="limitless-overlay"></div>
      <div class="limitless-content">
        <div class="limitless-date">9-10 February 2026 | Riyadh</div>
        <h2 class="limitless-title">Limitless Opportunities</h2>
        <p class="limitless-text">
          10X your business opportunities, meet key decision-makers in person and achieve your brand's goals.
        </p>
        <button class="limitless-btn" @click="scrollToTop">Book a Meeting</button>
      </div>
    </section>

    <!-- Past Exhibitors Section -->
    <section class="past-exhibitors-section">
      <div class="container-wide">
        <h2 class="exhibitors-title">Past Exhibitors</h2>
        <div class="exhibitors-grid">
          <div class="exhibitor-logo" v-for="(exhibitor, index) in exhibitors" :key="index">
            <img :src="exhibitor.logo" :alt="exhibitor.name" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ExhibitPage',
  data() {
    return {
      formData: {
        fullName: '',
        companyName: '',
        email: '',
        phone: ''
      },
      exhibitors: [
        { name: 'AIRIA', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/airia.webp' },
        { name: 'Freshworks', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/freshworks-2.webp' },
        { name: 'Salesforce', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/Salesforce.webp' },
        { name: 'Dataiku', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/dataiku.webp' },
        { name: 'Multiverse Computing', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/Multiverse-Computing-Participation.webp' },
        { name: 'DiAGEN.AI', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/diagenai.webp' },
        { name: 'Data Quantum', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/Data-Quantum.webp' },
        { name: 'Sophia', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/sophia.webp' },
        { name: 'AMD Cybersec', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/amd-cybersec.webp' },
        { name: 'AeroAegis', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/aeroaegis.webp' },
        { name: 'WAND', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/wand.webp' },
        { name: 'Kyvos', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/kyvos.webp' },
        { name: 'Ksolves', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/ksolves.webp' },
        { name: 'Xcelore', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/xcelore.webp' },
        { name: 'Gathr', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/gathr.webp' },
        { name: 'Seez', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/seez.webp' },
        { name: 'Propty', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/propty.webp' },
        { name: 'Exotel', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/Exotel.webp' },
        { name: 'TCALL', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/tcall.webp' },
        { name: 'SleekFlow', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/sleekflow.webp' },
        { name: 'Tring AI', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/tring_ai-e1750165847547.webp' },
        { name: 'GoGHR', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/goghr.webp' },
        { name: 'Mendcor', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/mendcor.webp' },
        { name: 'VentureDive', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/12/venturedive.webp' },
        { name: 'Qwerty Experts', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/12/Qwerty-Exprets.webp' },
        { name: 'Kama', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/12/Kama.webp' },
        { name: 'Tagglabs', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/Tagglabs.webp' },
        { name: 'SAAL', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/saal.svg' },
        { name: 'Amotion', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/amotion.webp' }
      ]
    }
  },
  methods: {
    handleSubmit() {
      console.log('Form submitted:', this.formData);
      // Handle form submission
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
</script>

<style scoped>
/* Hero Section */
.hero-section {
  position: relative;
  padding: 100px 20px;
  background: linear-gradient(135deg, #6B2DD8 0%, #8B5CF6 50%, #A78BFA 100%);
  background-image: url('https://www.globalaishow.com/wp-content/uploads/2024/08/bg-1.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  min-height: 600px;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 0;
}

.hero-container {
  position: relative;
  z-index: 1;
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 80px;
  align-items: center;
}

.hero-text {
  padding-right: 40px;
}

.page-title {
  font-size: 52px;
  font-weight: 700;
  color: #FFFFFF;
  margin: 0;
  line-height: 1.15;
  letter-spacing: -0.5px;
}

.hero-form {
  display: flex;
  justify-content: flex-end;
}

.form-card {
  background: white;
  border-radius: 12px;
  padding: 35px 30px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 480px;
  width: 100%;
}

.form-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 25px 0;
  line-height: 1.3;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.form-group input,
.form-group select {
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #6C5CE7;
  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
}

.submit-button {
  width: 100%;
  background: #6C5CE7;
  color: white;
  border: none;
  padding: 14px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
}

.submit-button:hover {
  background: #5b4bc4;
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(108, 92, 231, 0.3);
}

/* Responsive */
@media (max-width: 960px) {
  .hero-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .hero-text {
    padding-right: 0;
    text-align: center;
  }

  .page-title {
    font-size: 40px;
  }

  .hero-form {
    justify-content: center;
  }

  .form-card {
    max-width: 100%;
  }

  .hero-section {
    padding: 80px 20px;
    min-height: 500px;
  }
}

@media (max-width: 600px) {
  .hero-section {
    padding: 60px 15px;
    min-height: auto;
  }

  .page-title {
    font-size: 32px;
  }

  .form-card {
    padding: 30px 20px;
  }

  .form-title {
    font-size: 20px;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 15px;
    margin-bottom: 15px;
  }
}

/* Limitless Opportunities Section */
.limitless-section {
  position: relative;
  padding: 150px 20px;
  background-image: url('https://www.globalaishow.com/wp-content/uploads/2024/09/partner-hero-banner.webp');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.limitless-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 0;
}

.limitless-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
}

.limitless-date {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.limitless-title {
  font-size: 56px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 20px 0;
  line-height: 1.2;
  letter-spacing: -1px;
}

.limitless-text {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.95);
  margin: 0 0 35px 0;
  line-height: 1.6;
}

.limitless-btn {
  padding: 16px 48px;
  background: #ffffff;
  color: #6320EE;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);
}

.limitless-btn:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(255, 255, 255, 0.4);
}

/* Who Is This Conference For Section */
.conference-for-section {
  padding: 80px 20px;
  background: linear-gradient(135deg, #2D1B69 0%, #4A2B8F 50%, #5E3BA8 100%);
}

.conference-title {
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  margin: 0 0 60px 0;
  letter-spacing: -0.5px;
}

.conference-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 35px;
}

.conference-card {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 35px 30px;
  transition: all 0.3s ease;
}

.conference-card:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.conference-heading {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 25px 0;
  line-height: 1.3;
}

.conference-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.conference-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
}

.check-icon {
  width: 24px;
  height: 24px;
  background: #7FD8BE;
  color: #1a4d3a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
}

/* Container */
.container-wide {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* Who's Joining Section */
.whos-joining-section {
  padding: 80px 20px;
  background: #f8f9fa;
}

.joining-title {
  font-size: 40px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin: 0 0 50px 0;
  letter-spacing: -0.5px;
}

.stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 30px;
}

.stats-grid-bottom {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 30px;
}

.stats-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #666;
  margin: 0 0 20px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Region Stats */
.region-stats {
  padding: 0;
  overflow: hidden;
}

.region-bars {
  display: flex;
  height: 100%;
  min-height: 280px;
}

.region-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;
  color: #ffffff;
  position: relative;
}

.region-bar:nth-child(1) {
  background: #2D1B69;
}

.region-bar:nth-child(2) {
  background: #6B4FC7;
}

.region-bar:nth-child(3) {
  background: #5741B8;
}

.region-bar:nth-child(4) {
  background: #4A2B8F;
}

.region-bar:nth-child(5) {
  background: #8B7AC7;
}

.region-label {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 10px;
}

.region-name {
  font-size: 14px;
  font-weight: 500;
  opacity: 0.9;
}

/* Job Level Stats */
.job-level-stats {
  background: linear-gradient(180deg, #5AB89A 0%, #7DD4BC 20%, #9AE5CE 40%, #B5F0DD 60%, #CEF7E9 100%);
  padding: 0;
  overflow: hidden;
}

.job-level-stats .card-title {
  color: #1a4d3a;
  padding: 20px 20px 15px 20px;
  margin: 0;
}

.stat-item {
  padding: 18px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
}

.stat-item:last-child {
  border-bottom: none;
}

.stat-item:nth-child(2) {
  background: rgba(255, 255, 255, 0.05);
}

.stat-item:nth-child(3) {
  background: rgba(255, 255, 255, 0.1);
}

.stat-item:nth-child(4) {
  background: rgba(255, 255, 255, 0.15);
}

.stat-item:nth-child(5) {
  background: rgba(255, 255, 255, 0.2);
}

.stat-item:nth-child(6) {
  background: rgba(255, 255, 255, 0.25);
}

.stat-bar {
  display: none;
}

.stat-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: #1a4d3a;
}

.stat-percent {
  font-weight: 700;
  font-size: 24px;
  color: #0f3d2e;
}

.stat-label {
  font-weight: 500;
  font-size: 13px;
  color: #2a5545;
}

/* Company Size Stats */
.company-boxes {
  display: flex;
  gap: 15px;
}

.company-box {
  flex: 1;
  text-align: center;
  padding: 30px 15px;
  border-radius: 8px;
}

.company-box:nth-child(1) {
  background: #E8E8E8;
}

.company-box:nth-child(2) {
  background: #808080;
  color: #ffffff;
}

.company-box:nth-child(3) {
  background: #D0D0D0;
}

.company-percent {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 8px;
}

.company-range {
  font-size: 13px;
  font-weight: 500;
}

/* Sector Stats */
.sector-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.sector-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.sector-name {
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.sector-bar-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sector-bar {
  height: 24px;
  background: linear-gradient(90deg, #6B4FC7 0%, #8B7AC7 100%);
  border-radius: 4px;
  min-width: 20px;
}

.sector-percent {
  font-size: 13px;
  font-weight: 700;
  color: #333;
  min-width: 40px;
}

/* Gateway Section */
.gateway-section {
  padding: 80px 20px;
  background-image: url('https://www.globalaishow.com/wp-content/uploads/2024/08/frame5.webp');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.gateway-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.7) 100%);
  z-index: 0;
}

.gateway-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

.gateway-content {
  padding-right: 20px;
}

.gateway-title {
  font-size: 44px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 20px 0;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.gateway-text {
  font-size: 17px;
  color: #666;
  line-height: 1.7;
  margin: 0 0 30px 0;
}

.gateway-btn {
  padding: 16px 40px;
  background: linear-gradient(135deg, #6320EE, #7c3aed);
  color: #ffffff;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(99, 32, 238, 0.3);
}

.gateway-btn:hover {
  background: linear-gradient(135deg, #7c3aed, #8b4fed);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(99, 32, 238, 0.4);
}

.gateway-features {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.gateway-feature {
  display: flex;
  gap: 15px;
  align-items: flex-start;
  padding: 20px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  border-left: 4px solid #6320EE;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.feature-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #6320EE, #7c3aed);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.feature-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 6px 0;
  line-height: 1.3;
}

.feature-text {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* Package Banner Section */
.package-banner-section {
  padding: 50px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}

.banner-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.banner-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.banner-btn {
  padding: 14px 32px;
  background: linear-gradient(135deg, #6320EE, #7c3aed);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(99, 32, 238, 0.3);
}

.banner-btn:hover {
  background: linear-gradient(135deg, #7c3aed, #8b4fed);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(99, 32, 238, 0.4);
}

.banner-subtitle {
  font-size: 16px;
  color: #666;
  text-align: center;
  margin: 0;
  line-height: 1.6;
}

/* Top 3 Recommended Ways Section */
.top-ways-section {
  padding: 80px 20px;
  background: linear-gradient(135deg, #2D1B69 0%, #4A2B8F 50%, #6B3FC7 100%);
  position: relative;
  overflow: hidden;
}

.top-ways-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(139, 92, 246, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 80% 50%, rgba(107, 45, 216, 0.3) 0%, transparent 50%);
  z-index: 0;
}

.ways-title {
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  margin: 0 0 60px 0;
  position: relative;
  z-index: 1;
  letter-spacing: -0.5px;
}

.ways-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 35px;
  margin-bottom: 50px;
  position: relative;
  z-index: 1;
}

.way-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 35px 30px;
  transition: all 0.3s ease;
}

.way-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.way-heading {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 18px 0;
  line-height: 1.3;
}

.way-description {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.7;
  margin: 0;
}

.ways-cta {
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.ways-cta-btn {
  padding: 16px 48px;
  background: #ffffff;
  color: #6320EE;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.ways-cta-btn:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.3);
}

/* Responsive for new sections */
@media (max-width: 960px) {
  .limitless-section {
    padding: 120px 20px;
  }

  .limitless-title {
    font-size: 42px;
  }

  .limitless-text {
    font-size: 18px;
  }

  .conference-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .conference-title {
    font-size: 36px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stats-grid-bottom {
    grid-template-columns: 1fr;
  }

  .region-bars {
    min-height: 200px;
  }

  .company-boxes {
    flex-direction: column;
  }

  .gateway-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .gateway-title {
    font-size: 36px;
  }

  .banner-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .banner-title {
    font-size: 26px;
  }

  .ways-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .ways-title {
    font-size: 34px;
  }
}

@media (max-width: 600px) {
  .limitless-section {
    padding: 100px 15px;
    min-height: 400px;
  }

  .limitless-title {
    font-size: 32px;
  }

  .limitless-text {
    font-size: 16px;
  }

  .limitless-btn {
    width: 100%;
    padding: 16px 32px;
  }

  .conference-for-section {
    padding: 60px 15px;
  }

  .conference-title {
    font-size: 28px;
    margin-bottom: 40px;
  }

  .conference-card {
    padding: 28px 24px;
  }

  .conference-heading {
    font-size: 22px;
  }

  .whos-joining-section {
    padding: 60px 15px;
  }

  .joining-title {
    font-size: 28px;
    margin-bottom: 35px;
  }

  .stats-card {
    padding: 20px;
  }

  .gateway-section {
    padding: 60px 15px;
  }

  .gateway-title {
    font-size: 28px;
  }

  .gateway-text {
    font-size: 15px;
  }

  .gateway-btn {
    width: 100%;
  }

  .gateway-feature {
    padding: 15px;
  }

  .feature-icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }

  .region-bars {
    flex-direction: column;
    min-height: auto;
  }

  .region-bar {
    min-height: 60px;
  }

  .region-label {
    font-size: 22px;
  }

  .company-percent {
    font-size: 28px;
  }

  .package-banner-section {
    padding: 40px 15px;
  }

  .banner-title {
    font-size: 22px;
  }

  .banner-subtitle {
    font-size: 14px;
  }

  .top-ways-section {
    padding: 60px 15px;
  }

  .ways-title {
    font-size: 28px;
    margin-bottom: 40px;
  }

  .way-card {
    padding: 28px 24px;
  }

  .way-heading {
    font-size: 20px;
  }

  .way-description {
    font-size: 14px;
  }

  .ways-cta-btn {
    width: 100%;
    padding: 16px 32px;
  }
}

/* Past Exhibitors Section */
.past-exhibitors-section {
  padding: 80px 20px;
  background: #f8f9fa;
}

.exhibitors-title {
  font-size: 40px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin: 0 0 50px 0;
  letter-spacing: -0.5px;
}

.exhibitors-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 25px;
  align-items: center;
}

.exhibitor-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  background: #ffffff;
  border-radius: 8px;
  min-height: 120px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.exhibitor-logo:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.exhibitor-logo img {
  max-width: 100%;
  max-height: 70px;
  height: auto;
  width: auto;
  filter: grayscale(0%);
  opacity: 1;
  transition: all 0.3s ease;
}

.exhibitor-logo:hover img {
  filter: grayscale(0%);
  opacity: 1;
  transform: scale(1.05);
}

/* Responsive for Past Exhibitors */
@media (max-width: 960px) {
  .exhibitors-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
}

@media (max-width: 600px) {
  .past-exhibitors-section {
    padding: 60px 15px;
  }

  .exhibitors-title {
    font-size: 28px;
    margin-bottom: 35px;
  }

  .exhibitors-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .exhibitor-logo {
    padding: 20px;
    min-height: 100px;
  }

  .exhibitor-logo img {
    max-height: 60px;
  }
}
</style>
